"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlEditButton = void 0;
require("./styles.css");
var quill_1 = __importDefault(require("quill"));
function $create(elName) {
    return document.createElement(elName);
}
function $setAttr(el, key, value) {
    return el.setAttribute(key, value);
}
var debug = false;
var Logger = {
    prefixString: function () {
        return "</> quill-html-edit-button: ";
    },
    get log() {
        if (!debug) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
            };
        }
        var boundLogFn = console.log.bind(console, this.prefixString());
        return boundLogFn;
    },
};
var htmlEditButton = /** @class */ (function () {
    function htmlEditButton(quill, optionsInput) {
        var options = optionsInput || {};
        debug = !!(options && options.debug);
        Logger.log("logging enabled");
        // Add button to all quill toolbar instances
        var toolbarModule = quill.getModule("toolbar");
        if (!toolbarModule) {
            throw new Error('quill.htmlEditButton requires the "toolbar" module to be included too');
        }
        this.registerDivModule();
        var toolbarEl = toolbarModule.container;
        var buttonContainer = $create("span");
        $setAttr(buttonContainer, "class", "ql-formats");
        var button = $create("button");
        button.innerHTML = options.buttonHTML || "&lt;&gt;";
        button.title = options.buttonTitle || "Show HTML source";
        button.onclick = function (e) {
            e.preventDefault();
            launchPopupEditor(quill, options);
        };
        buttonContainer.appendChild(button);
        toolbarEl.appendChild(buttonContainer);
    }
    htmlEditButton.prototype.registerDivModule = function () {
        // To allow divs to be inserted into html editor
        // obtained from issue: https://github.com/quilljs/quill/issues/2040
        var Block = quill_1.default.import("blots/block");
        var Div = /** @class */ (function (_super) {
            __extends(Div, _super);
            function Div() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Div;
        }(Block));
        Div.tagName = "div";
        Div.blotName = "div";
        Div.allowedChildren = Block.allowedChildren;
        Div.allowedChildren.push(Block);
        quill_1.default.register(Div);
    };
    return htmlEditButton;
}());
exports.htmlEditButton = htmlEditButton;
function launchPopupEditor(quill, options) {
    var htmlFromEditor = quill.container.querySelector(".ql-editor").innerHTML;
    var popupContainer = $create("div");
    var overlayContainer = $create("div");
    var msg = options.msg ||
        'Edit HTML here, when you click "OK" the quill editor\'s contents will be replaced';
    var cancelText = options.cancelText || "Cancel";
    var okText = options.okText || "Ok";
    var closeOnClickOverlay = options.closeOnClickOverlay !== false;
    $setAttr(overlayContainer, "class", "ql-html-overlayContainer");
    $setAttr(popupContainer, "class", "ql-html-popupContainer");
    var popupTitle = $create("span");
    $setAttr(popupTitle, "class", "ql-html-popupTitle");
    popupTitle.innerText = msg;
    var textContainer = $create("div");
    textContainer.appendChild(popupTitle);
    $setAttr(textContainer, "class", "ql-html-textContainer");
    var codeBlock = $create("pre");
    $setAttr(codeBlock, "data-language", "xml");
    codeBlock.innerText = formatHTML(htmlFromEditor);
    var htmlEditor = $create("div");
    $setAttr(htmlEditor, "class", "ql-html-textArea");
    var buttonCancel = $create("button");
    buttonCancel.innerHTML = cancelText;
    $setAttr(buttonCancel, "class", "ql-html-buttonCancel");
    var buttonOk = $create("button");
    buttonOk.innerHTML = okText;
    $setAttr(buttonOk, "class", "ql-html-buttonOk");
    var buttonGroup = $create("div");
    $setAttr(buttonGroup, "class", "ql-html-buttonGroup");
    var prependSelector = document.querySelector(options.prependSelector);
    buttonGroup.appendChild(buttonCancel);
    buttonGroup.appendChild(buttonOk);
    htmlEditor.appendChild(codeBlock);
    textContainer.appendChild(htmlEditor);
    textContainer.appendChild(buttonGroup);
    popupContainer.appendChild(textContainer);
    overlayContainer.appendChild(popupContainer);
    if (prependSelector) {
        prependSelector.prepend(overlayContainer);
    }
    else {
        document.body.appendChild(overlayContainer);
    }
    var modules = options && options.editorModules;
    var hasModules = !!modules && !!Object.keys(modules).length;
    var modulesSafe = hasModules ? modules : {};
    // console.time('new Quill')
    var editor = new quill_1.default(htmlEditor, {
        modules: __assign({ syntax: options.syntax }, modulesSafe),
    });
    // console.timeEnd('new Quill')
    buttonCancel.onclick = function () {
        if (prependSelector) {
            prependSelector.removeChild(overlayContainer);
        }
        else {
            document.body.removeChild(overlayContainer);
        }
    };
    if (closeOnClickOverlay) {
        overlayContainer.onclick = buttonCancel.onclick;
    }
    popupContainer.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    buttonOk.onclick = function () {
        var container = editor.container;
        var qlElement = container.querySelector(".ql-editor");
        var output = qlElement.innerText;
        var noNewlines = output
            .replace(/\s+/g, " ") // convert multiple spaces to a single space. This is how HTML treats them
            .replace(/(<[^\/<>]+>)\s+/g, "$1") // remove spaces after the start of a new tag
            .replace(/>\s+|\s+</g, function (m) { return m.trim(); }) // remove spaces between starting and ending tags
            .replace(/<\/(p|ol|ul)>\s/g, "</$1>") // remove spaces after the end of lists and paragraphs, they tend to break quill
            .replace(/\s<(p|ol|ul)>/g, "<$1>") // remove spaces before the start of lists and paragraphs, they tend to break quill
            .replace(/<\/li>\s<li>/g, "</li><li>") // remove spaces between list items, they tend to break quill
            .replace(/\s<\//g, "</") // remove spaces before the end of tags
            .replace(/(<[^\/<>]+>)\s(<[^\/<>]+>)/g, "$1$2") // remove space between multiple starting tags
            .trim();
        quill.container.querySelector(".ql-editor").innerHTML = noNewlines;
        if (prependSelector) {
            prependSelector.removeChild(overlayContainer);
        }
        else {
            document.body.removeChild(overlayContainer);
        }
    };
}
// Adapted FROM jsfiddle here: https://jsfiddle.net/buksy/rxucg1gd/
function formatHTML(code) {
    "use strict";
    var stripWhiteSpaces = true;
    var stripEmptyLines = true;
    var whitespace = " ".repeat(2); // Default indenting 4 whitespaces
    var currentIndent = 0;
    var newlineChar = "\n";
    var prevChar = null;
    var char = null;
    var nextChar = null;
    var result = "";
    for (var pos = 0; pos <= code.length; pos++) {
        prevChar = char;
        char = code.substr(pos, 1);
        nextChar = code.substr(pos + 1, 1);
        var isBrTag = code.substr(pos, 4) === "<br>";
        var isOpeningTag = char === "<" && nextChar !== "/" && !isBrTag;
        var isClosingTag = char === "<" && nextChar === "/" && !isBrTag;
        var isTagEnd = prevChar === ">" && char !== "<" && currentIndent > 0;
        var isTagNext = !isBrTag &&
            !isOpeningTag &&
            !isClosingTag &&
            isTagEnd &&
            code.substr(pos, code.substr(pos).indexOf("<")).trim() === "";
        if (isBrTag) {
            // If opening tag, add newline character and indention
            result += newlineChar;
            currentIndent--;
            pos += 4;
        }
        if (isOpeningTag) {
            // If opening tag, add newline character and indention
            result += newlineChar + whitespace.repeat(currentIndent);
            currentIndent++;
        }
        // if Closing tag, add newline and indention
        else if (isClosingTag) {
            // If there're more closing tags than opening
            if (--currentIndent < 0)
                currentIndent = 0;
            result += newlineChar + whitespace.repeat(currentIndent);
        }
        // remove multiple whitespaces
        else if (stripWhiteSpaces === true && char === " " && nextChar === " ")
            char = "";
        // remove empty lines
        else if (stripEmptyLines === true && char === newlineChar) {
            //debugger;
            if (code.substr(pos, code.substr(pos).indexOf("<")).trim() === "")
                char = "";
        }
        if (isTagEnd && !isTagNext) {
            result += newlineChar + whitespace.repeat(currentIndent);
        }
        result += char;
    }
    Logger.log("formatHTML", {
        before: code,
        after: result,
    });
    return result;
}
window["htmlEditButton"] = htmlEditButton;
exports.default = htmlEditButton;
